import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircleNotComplete = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.25 3.75098C7.69359 3.75098 4 7.44457 4 12.001C4 16.5563 7.69354 20.25 12.25 20.25C16.8065 20.25 20.5 16.5563 20.5 12.001C20.5 7.44457 16.8064 3.75098 12.25 3.75098ZM2.5 12.001C2.5 6.61614 6.86516 2.25098 12.25 2.25098C17.6348 2.25098 22 6.61614 22 12.001C22 17.3849 17.6348 21.75 12.25 21.75C6.86522 21.75 2.5 17.3849 2.5 12.001Z",
		fill: "currentColor"
	})
});
export default SvgCircleNotComplete;
